import { RuleProps } from 'types/application';

export const LICENCE_CATEGORY = 'licence-category';
export const FREQUENCY_ENTRY = 'frequency-entry';
export const STATION = 'station';
export const BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION = 'based-land-fixed-station-with-mobile-portable-station';
export const BASED_LAND_FIXED_STATION_INFORMATION = 'based-land-fixed-station-information';
export const OTHER_DETAILS = 'other-details';
export const STATION_ADDRESS = 'station-address';
export const LATITUDE = 'latitude';
export const LONGITUDE = 'longitude';
export const VENDOR_INFORMATION = 'vendor-information';
export const VENDOR_ADDRESS = 'vendor-address';
export const RADIO_EQUIPMENT_INFORMATION = 'radio-equipment-information';
export const ANTENNA_INFORMATION = 'antenna-information';
export const ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION = 'antenna-displacement-from-station-location';
export const FILTER_INFORMATION = 'filter-information';
export const FEEDER_INFORMATION = 'feeder-information';
export const FREQUENCY_AND_EMISSION_CLASS_INFORMATION = 'frequency-and-emission-class-information';
export const MOBILE = 'mobile';
export const MOBILE_PORTABLE_STATION_APPLICATION = 'mobile-portable-station-application';
export const MOBILE_LATITUDE = 'mobile-latitude';
export const MOBILE_LONGITUDE = 'mobile-longitude';
export const MOBILE_FREQUENCY_INFORMATION = 'mobile-frequency-information';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const WPN_APPLICATION = [
    {
        sectionID: LICENCE_CATEGORY,
        sectionName: '',
        fieldList: [
            {
                id: 'licence-category',
                label: 'Licence Category',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'proposed-used-of-system',
                label: 'Proposed use of System/Equipment',
                type: 'text',
                span: 12
            },
            {
                id: 'remarks-by-applicant',
                label: 'Remarks by Applicant (Optional)',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: VENDOR_INFORMATION,
        sectionName: 'Vendor Information',
        fieldList: [
            {
                id: 'company-name',
                label: 'Company Name',
                type: 'text'
            },
            {
                id: 'vendor-dealers-licence-number',
                label: "Vendor Dealer's Licence Number (Optional)",
                type: 'text'
            },
            {
                id: 'contact-person',
                label: 'Contact Person Name',
                type: 'text'
            },
            {
                id: 'contact-number',
                label: 'Contact Number (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_ADDRESS,
        sectionName: 'Vendor Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name (Optional)',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION,
        sectionName: 'Base/Land Fixed Station with Mobile/Portable Station',
        fieldList: [
            {
                id: 'station-type',
                label: 'Station Type',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION,
        sectionName: '',
        fieldList: [
            {
                id: 'station-name',
                label: 'Station Name',
                type: 'select'
            },
            {
                id: 'total-number-of-stations',
                label: 'Total Number of Station(s)',
                type: 'text'
            }
        ],
        rule: {
            baseIds: [`${BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION}-station-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(
                    baseValues &&
                        (baseValues[`${BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION}-station-type`] === 'Mobile Station Only' ||
                            baseValues[`${BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION}-station-type`] === 'Portable Only')
                );
                return result;
            }
        }
    },
    {
        sectionID: BASED_LAND_FIXED_STATION_INFORMATION,
        sectionName: 'Base/Land Fixed Station Information',
        fieldList: [
            {
                id: 'call-sign',
                label: 'Call Sign (Optional)',
                type: 'text'
            },
            {
                id: 'station-name',
                label: 'Station Name',
                type: 'text'
            },
            {
                id: 'location-of-station',
                label: 'Location of Station (e.g. Rooftop)',
                type: 'text'
            },
            {
                id: 'date-of-comissioning',
                label: 'Date of Comissioning',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION_ADDRESS,
        sectionName: 'Station Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LATITUDE,
        sectionName: 'Latitude',
        fieldList: [
            {
                id: 'latitude-degrees',
                label: 'Latitude Degrees',
                type: 'text'
            },
            {
                id: 'latitude-minutes',
                label: 'Latitude Minutes',
                type: 'text'
            },
            {
                id: 'latitude-seconds',
                label: 'Latitude Seconds',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LONGITUDE,
        sectionName: 'Longitude',
        fieldList: [
            {
                id: 'longitude-degrees',
                label: 'Longitude Degrees',
                type: 'text'
            },
            {
                id: 'longitude-minutes',
                label: 'Longitude Minutes',
                type: 'text'
            },
            {
                id: 'longitude-seconds',
                label: 'Longitude Seconds',
                type: 'text',
                span: 12
            },
            {
                id: 'building-height',
                label: 'Building Height (m)',
                type: 'text'
            },
            {
                id: 'antenna-effective-height',
                label: 'Antenna Effective Height (m) (above ground level)',
                type: 'text'
            },
            {
                id: 'elavation-above-mean-sea-level',
                label: 'Elevation Above Mean Sea Level(m)',
                type: 'text',
                span: 12
            },
            {
                id: 'transportable',
                label: 'Transportable? (Optional)',
                type: 'text'
            },
            {
                id: 'coverage-radius-link-distance',
                label: 'Coverage Radius Link Distance (km)',
                type: 'text',
                rule: {
                    baseIds: [`${LONGITUDE}-transportable`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${LONGITUDE}-transportable`] === 'Yes');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: RADIO_EQUIPMENT_INFORMATION,
        sectionName: 'Radio Equipment Information',
        fieldList: [
            {
                id: 'manufacturer-transmitter',
                label: 'Manufacturer (Transmitter)',
                type: 'text'
            },
            {
                id: 'manufacturer-receiver',
                label: 'Manufacturer (Receiver)',
                type: 'text'
            },
            {
                id: 'model-transmitter',
                label: 'Model (Transmitter)',
                type: 'text'
            },
            {
                id: 'model-receiver',
                label: 'Model (Receiver)',
                type: 'text'
            },
            {
                id: 'output-power',
                label: 'Output Power (W) (Transmitter) (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ANTENNA_INFORMATION,
        sectionName: 'Antenna Information',
        fieldList: [
            {
                id: 'antenna-manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'polarization',
                label: 'Polarization (Optional)',
                type: 'text'
            },
            {
                id: 'if-others-please-specify',
                label: 'If others, please specify',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${ANTENNA_INFORMATION}-polarization`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = !Boolean(baseValues && baseValues[`${ANTENNA_INFORMATION}-polarization`] === 'Others');
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION,
        sectionName: 'Antenna Displacement From Station Location',
        fieldList: [
            {
                id: 'north-latitude-displacement',
                label: 'North Latitude Displacement (m) (Optional)',
                type: 'text'
            },
            {
                id: 'east-longitude-displacement',
                label: 'East Longitude Displacement (m) (Optional)',
                type: 'text'
            },
            {
                id: 'gain-db',
                label: 'Gain (dB)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FILTER_INFORMATION,
        sectionName: 'Filter Information',
        fieldList: [
            {
                id: 'filter-manufacturer',
                label: 'Filter Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model (Optional)',
                type: 'text'
            },
            {
                id: 'insertion-loss',
                label: 'Insertion Loss (dB)',
                type: 'text'
            },
            {
                id: 'tuned-frequency',
                label: 'Tuned Frequency (MHz) (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FEEDER_INFORMATION,
        sectionName: 'Feeder Information',
        fieldList: [
            {
                id: 'feeder-line-type-transmit',
                label: 'Feeder Line Type (Transmit)',
                type: 'text'
            },
            {
                id: 'feeder-line-type-receive',
                label: 'Feeder Line Type (Receive)',
                type: 'text'
            },
            {
                id: 'feeder-line-length-transmit',
                label: 'Feeder Line Length(M)(Transmit)',
                type: 'text'
            },
            {
                id: 'feeder-line-length-receive',
                label: 'Feeder Line Length(M) (Receive)',
                type: 'text'
            },
            {
                id: 'feeder-line-loss-transmit',
                label: 'Feeder Line Loss(dB) (Transmit) (Optional)',
                type: 'text'
            },
            {
                id: 'feeder-line-loss-receive',
                label: 'Feeder Line Loss(dB) (Receive) (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FREQUENCY_AND_EMISSION_CLASS_INFORMATION,
        sectionName: 'Frequency and Emission Class Information',
        fieldList: [
            {
                id: 'frequency-and-emission-class-information-list',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'frequency-and-emission-class-info-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'sn',
                                header: 'S/N',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-tx',
                                header: 'Desired Frequency (MHz) - From (Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-tx',
                                header: 'Desired Frequency (MHz) - To (Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-rx',
                                header: 'Desired Frequency (MHz) - From (Rx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-rx',
                                header: 'Desired Frequency (MHz) - To (Rx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-bandwidth-khz-tx',
                                header: 'Bandwidth (kHz)(Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-bandwidth-khz-rx',
                                header: 'Bandwidth (kHz)(Rx)',
                                type: 'text'
                            },
                            {
                                id: 'start-time',
                                header: 'Start Time',
                                type: 'text'
                            },
                            {
                                id: 'stop-time',
                                header: 'Stop Time',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'frequency-and-emission-class-info-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: [
                            {
                                id: 'emission-class-transmit',
                                label: 'Emission Class - Transmit',
                                type: 'text'
                            },
                            {
                                id: 'emission-class-receive',
                                label: 'Emission Class - Receive',
                                type: 'text'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: MOBILE,
        sectionName: '',
        fieldList: [
            {
                id: 'portable-name',
                label: 'Portable Name',
                type: 'select-mobile'
            }
        ],
        rule: {
            baseIds: [`${BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION}-station-type`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(
                    baseValues &&
                        baseValues[`${BASED_LAND_FIXED_STATION_WITH_MOBILE_PORTABLE_STATION}-station-type`] ===
                            'Base/Land Fixed Station only'
                );
                return result;
            }
        }
    },
    {
        sectionID: MOBILE_PORTABLE_STATION_APPLICATION,
        sectionName: 'Mobile/Portable Station Application',
        fieldList: [
            {
                id: 'date-of-commissioning',
                label: 'Date of Commissioning',
                type: 'text'
            },
            {
                id: 'no-of-mobiles',
                label: 'No of Mobile(s)',
                type: 'text'
            },
            {
                id: 'coverage-information',
                label: 'Coverage Information',
                type: 'lists'
            },
            {
                id: 'mobiles-communicate-with',
                label: 'Mobile(s) Communicate With',
                type: 'lists'
            },
            {
                id: 'portables-communicate-with',
                label: 'Portable(s) Communicate With',
                type: 'lists'
            }
        ]
    },
    {
        sectionID: MOBILE_LATITUDE,
        sectionName: 'Latitude (Mobile)',
        fieldList: [
            {
                id: 'latitude-degrees',
                label: 'Latitude Degrees',
                type: 'text'
            },
            {
                id: 'latitude-minutes',
                label: 'Latitude Minutes',
                type: 'text'
            },
            {
                id: 'latitude-seconds',
                label: 'Latitude Seconds',
                type: 'text'
            }
        ]
    },
    {
        sectionID: MOBILE_LONGITUDE,
        sectionName: 'Longitude (Mobile)',
        fieldList: [
            {
                id: 'longitude-degrees',
                label: 'Longitude Degrees',
                type: 'text'
            },
            {
                id: 'longitude-minutes',
                label: 'Longitude Minutes',
                type: 'text'
            },
            {
                id: 'longitude-seconds',
                label: 'Longitude Seconds',
                type: 'text',
                span: 12
            },
            {
                id: 'radius-of-operation',
                label: 'Radius of Operation (km)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: MOBILE_FREQUENCY_INFORMATION,
        sectionName: 'Frequency Information (Mobile/Portable Station)',
        fieldList: [
            {
                id: 'mobile-frequency-information-list',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'mobile-frequency-info-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'sn',
                                header: 'S/N',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-tx',
                                header: 'Desired Frequency (MHz) - From (Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-tx',
                                header: 'Desired Frequency (MHz) - To (Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-rx',
                                header: 'Desired Frequency (MHz) - From (Rx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-rx',
                                header: 'Desired Frequency (MHz) - To (Rx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-bandwidth-khz-tx',
                                header: 'Desired Bandwidth (kHz)(Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-bandwidth-khz-rx',
                                header: 'Desired Bandwidth (kHz)(Rx)',
                                type: 'text'
                            },
                            {
                                id: 'start-time',
                                header: 'Start Time',
                                type: 'text'
                            },
                            {
                                id: 'stop-time',
                                header: 'Stop Time',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'frequency-and-emission-class-info-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: [
                            {
                                id: 'manufacturer',
                                label: 'Manufacturer',
                                type: 'text'
                            },
                            {
                                id: 'model',
                                label: 'Model',
                                type: 'text'
                            },
                            {
                                id: 'equipment-type',
                                label: 'Equipment Type',
                                type: 'text'
                            },
                            {
                                id: '',
                                label: '',
                                type: 'text'
                            },
                            {
                                id: 'emission-class-transmit',
                                label: 'Emission Class - Transmit',
                                type: 'text'
                            },
                            {
                                id: 'emission-class-receive',
                                label: 'Emission Class - Receive',
                                type: 'text'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
